import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowseService {
  public surveyStart:string = '';
  public surveyEnd:string = ''
  constructor() { }
}
